module.exports = __webpack_public_path__ + "img/logone.4cdf3840.png";